import { render } from "./ListCreateOrEdit.vue?vue&type=template&id=0a699752&scoped=true"
import script from "./ListCreateOrEdit.vue?vue&type=script&lang=js"
export * from "./ListCreateOrEdit.vue?vue&type=script&lang=js"

import "./ListCreateOrEdit.vue?vue&type=style&index=0&id=0a699752&scoped=true&lang=css"

import exportComponent from "C:\\Git_repos\\MovieVote\\movievote-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a699752"]])

export default __exports__